module.exports = __webpack_public_path__ + "media/images/shield_black-d74493b8.png";